import { createContext, useContext } from 'react';

const AddonsOverviewContext = createContext({});

AddonsOverviewContext.displayName = 'AddonsOverviewContext';

const useAddonsOverview = () => useContext(AddonsOverviewContext);

export { AddonsOverviewContext, useAddonsOverview };
